"use client";
import React, {useEffect, useState} from "react";
import apiFetcher from "../../../provider/magento/apiFetcher";
import {getShippingTime} from "../../../provider/magento/api/products";
import TruckIcon from "@heroicons/react/24/outline/TruckIcon";
import {Loader} from "../Loader/Loader";
import {usePhrase} from "../../i18n";

const ProductShippingBox = ({product, storeCode, storeLocale, storeTimezone, _t, light = false}) => {

    const t = usePhrase(_t);

    const [startLoading, setStartLoading] = useState(false);
    const [shippingTime, setShippingTime] = useState(null);
    const [shippingLastTime, setShippingLastTime] = useState(null);
    const [shippingTimeDifference, setShippingTimeDifference] = useState(null);




    useEffect(() => {
        if(!product?.id) return;
        if(startLoading) return;
        setStartLoading(true);
        apiFetcher(...getShippingTime(product.id, storeCode)).then(res => {
            if (!res?.shipping_date) return;
            setShippingTime(parseInt(res.shipping_date * 1000))
            setShippingLastTime(parseInt(res.shipping_last_date * 1000))
        });
    }, []);


    useEffect(() => {
        if (shippingLastTime) {
            const endOfDay = new Date();//.setHours(23, 59, 59, 999);
            const shippingTimeDifference = Math.abs(shippingLastTime - endOfDay);
            setShippingTimeDifference({
                days: Math.floor(shippingTimeDifference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((shippingTimeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                minutes: Math.floor(((shippingTimeDifference % (1000 * 60 * 60 * 24)) % (1000 * 60 * 60)) / (1000 * 60))
            });
        }
    }, [shippingLastTime]);


    if (!shippingTime) return;


    if (light) {
        return <>

            <div className={`bg-[#e7bb43] rounded-md px-2 flex justify-center items-center mb-2`}>
                <TruckIcon className={'w-12 h-12 stroke-1 mr-3 text-white'}/>
                <span className={`text-sm lg:text-xs text-white uppercase text-center`}>{t('Free shipping')}</span>
            </div>

            <p className={`text-md lg:text-sm`}>{t('Free shipping scheduled for the day:')}
            <span className={'font-bold ml-0.5'}>
                {shippingTime ? `${new Date(shippingTime).toLocaleString(storeLocale, {weekday: "long",timeZone: storeTimezone}).toString()}, ${new Date(shippingTime).toLocaleString(storeLocale, {
                    day: "numeric",
                    month: "long",
                    timeZone: storeTimezone
                })}` : '/'}.
            </span>
            {shippingTimeDifference && <>
            <span className={'ml-0.5'}>{t('If you order within:')}</span>
            <span className={'font-bold ml-1'}>
                {shippingTimeDifference.days > 0 && <>{shippingTimeDifference.days} {t('days')}</>}
                {shippingTimeDifference.days > 0 && shippingTimeDifference.hours > 0 && <> {t('and')} </>}
                {shippingTimeDifference.hours > 0 && <>{shippingTimeDifference.hours} {t('hours')}</>}
                {shippingTimeDifference.hours > 0 && shippingTimeDifference.minutes > 0 && <> {t('and')} </>}
                {shippingTimeDifference.minutes > 0 && <>{shippingTimeDifference.minutes} {t('minutes')}</>}
            </span>
            </>}
        </p>
            </>


    }

    return <div className={'flex items-center bg-[#eee] rounded px-2 py-2'}>
        <div>
            <TruckIcon className={'w-12 h-12 stroke-1 mr-3'}/>
        </div>
        <div className={'text-sm md:text-md'}>
            <p className={''}>{t('Guaranteed free shipping within:')}</p>
            <p className={'capitalize font-bold'}>{shippingTime ? `${new Date(shippingTime).toLocaleString(storeLocale, {weekday: "long"}).toString()} ${new Date(shippingTime).toLocaleDateString(storeLocale)}` : '/'}</p>
            <span className={''}>{t('If you order within:')}</span>
            <span className={'font-bold ml-1'}>{shippingTimeDifference && <>
                {parseInt(shippingTimeDifference.days) > 0 && <>{shippingTimeDifference.days} {t('days')} {t('and')}</>}
                {shippingTimeDifference.hours} {t('hours')}
            </>}
            </span>
        </div>
    </div>;

}

export default ProductShippingBox;